export default class Config
{

    constructor()
    {

        if( !Config.instance )
        {

            this.setConfig()
            Config.instance = this

        }

        return Config.instance

    }

    destruct()
    {
        delete Config.instance
    }

    setConfig()
    {

        this.product = 'upgrait-uhc'
        this.versionNumber = '0.2.0'
        this.codeName = 'valid viper'

        this.build = process.env.VERSION.substring( 0, 8 )
        this.branch = process.env.BRANCH

        this.version = this.versionNumber + '-'
                       + ( this.codeName !== false ? this.codeName + '-' : '' )
                       + this.branch + ' (' + this.build + ')'

        this.commitHash = process.env.COMMIT_HASH
        this.verbosity = 99
        this.server = 'localhost'

        this.baseUri = ''
        this.endpoint = 'wss'

        this.maxTickTimeout = ( 60 * 60000 )
        this.configureBranch()

        Config.instance = this

    }

    configureBranch()
    {
        /*
        switch( this.branch )
        {
            case 'local':
                this.baseUri = 'http://localhost:8081/#/'
                this.server = 'uhc-test.angerco.de'
                this.verbosity = 9
                break
            case 'master':
            case 'dev':
                this.server = 'uhc-test.angerco.de'
                this.verbosity = 9
                break
            case 'beta':
                this.server = 'uhc-beta.angerco.de'
                this.verbosity = 3
                break
            case 'live':
                this.server = 'uhc-app.angerco.de'
                this.verbosity = 1
                break
        }

        this.baseUri = this.baseUri || 'https://' + this.server + '/#/'
        this.endpoint = 'cwss'

        this.socketUrl = 'wss://' + this.server + '/' + this.endpoint + '/'*/

        this.socketUrl = 'proxy.heatcontrol.upgrait.me:6699/'

    }

    isDevBranch()
    {
        return ( 'local' === this.branch || 'dev' === this.branch )
    }

    getBuild()
    {
        return this.build
    }

    refresh()
    {
        this.setConfig()
    }

}